/**
 * Created by RKL on 21/08/2015.
 */
define('runTemplatesShowView',[
  'module',
  'underscore',
  'backbone',
  'jqgridView',
  'dateUtils',
  'urlUtil',
  'app',
  'settings',
  'template!runTemplatesViewTpl',
  'datePickerPopoverMixin',
  'jqgridActionsButtonFormatterActions',
  'jqgridActionsButtonFormatterView',
  'bootbox'
], function(
  module,
  _,
  Backbone,
  JqGridView,
  dateConverter,
  UrlUtil,
  App,
  Settings,
  viewTpl,
  datePickerPopoverMixin,
  availableActions,
  ActionButtonsView,
  bootbox
) {
  'use strict';

  var RunTemplatesView =  JqGridView.extend({
    template: viewTpl,
    filtersName: 'runsFilters',

    regions: {
      runsActions: '.js-action-buttons-region'
    },

    ui: function() {
      return _.extend({
        jqGrid: '#jq-grid-list',
        jqGridPager: '#jq-grid-pager-list',
        deleteRun: '.delete-run-link'
      }, this.gridUi);
    },

    events: {
      'click @ui.deleteRun': 'onDeleteRun'
    },

    onShow: function() {
      $.material.init();
    },

    serializeData: function () {
      this.selectedRuns = Settings.get('selectedRunTemplates') || [];
      var templateData = {
        'type': 'runtemplates'
      };
      return templateData;
    },

    onDeleteRun: function(event){
      this.trigger('runtemplate:delete', $(event.currentTarget).find('span').attr('data-row-id'));
    },

    gridOptions: function(data) {
      var that = this,
        defaultsOptions = this.gridInitOptions(data),
        options = {
          colModel: [{
            label: '',
            name: 'secId',
            key: true,
            hidden: true
          },{
              label: _.i18n('runList.name'),
              name: 'name',
              classes: 'order-link',
              formatter: this.defaultFormatter,
              search: false,
              index: 'name',
              width: 50
            }, {
              label: _.i18n('runList.refLmbAnalyzer'),
              name: 'refLmbAnalyzer.code',
              classes: 'order-link',
              formatter: this.defaultFormatter,
              search: false,
              index: 'refLmbAnalyzer.code'
            }, {
              label: ' ',
              name: 'delete',
              search: false,
              classes: 'delete-run-link delete-link',
              formatter: this.deleteIconFormatter,
              width: 20
            }
          ],

          serializeGridData: function (postData) {
            if (postData.status === that.selectDefault) {
              delete postData.status;
            }

            if (postData.modDate) {
              postData.dateFrom = datePickerPopoverMixin.parseDateFrom(postData.modDate);
              postData.dateTo = datePickerPopoverMixin.parseDateTo(postData.modDate);
            } else if (!that.sorting) {
              delete postData.dateFrom;
              delete postData.dateTo;
            }
            that.sorting = false;
            defaultsOptions.serializeGridData.apply(this, arguments);

            return postData;
          },

          gridComplete: function() {
            var purchaseOrderId = UrlUtil.parseQueryString().purchaseOrderId;
            if(purchaseOrderId) {
              UrlUtil.clearQueryString();
              that.preselectFirstRow();
            }
            defaultsOptions.gridComplete.apply(this, arguments);
            that.checkRunsSelection();
          },

          onSelectRow: function(rowId, bool, e) {
            if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
              var cellUpdated = that.$('.cell-payedToManufacturer, .cell-payedByCustomer');

              if (e.type === 'click' && cellUpdated.has(e.target).length === 0) {
                var route = App.getCurrentRoute() ===  'runtemplates' ? App.getCurrentRoute() : 'runtemplates/' + App.getCurrentRoute();
                App.navigate(route + '/' + rowId, {trigger: true});
              }
            }
          }
        };

      options = _.defaults(options, defaultsOptions);

      return options;
    },

    /*
     * runs selection with ctrl/shift keys
    */

    manageCtrlKey: function(grid, rowid) {
      var maxSelectedRunsNumber = 100,
          $row = grid.find('#' + rowid);
      if ($row.hasClass('selected')) {
        $row.removeClass('selected');
        this.onRowMultiselect(rowid, false);
      } else {
        if (this.selectedRuns.length === maxSelectedRunsNumber) {
          this.showWarningSelectedNumberOutOfRange();
        } else {
          $row.addClass('selected');
          this.onRowMultiselect(rowid, true);
        }
      }
    },

    manageShiftKey: function(grid, rowid) {
      var firstSelectedOrder = this.getFirstSelectedOrder(),
          lastSelectedRow = grid.find('#' + rowid),
          gridRows = grid.find('tr'),
          lastIndex = gridRows.index(lastSelectedRow),
          lastSelectedOrder = {
            rowid: rowid,
            page: this.pagination.currentPage,
            index: lastIndex
          };

      if (!firstSelectedOrder) firstSelectedOrder = lastSelectedOrder;
      if (firstSelectedOrder.page > lastSelectedOrder.page) {
        this.swapRuns(firstSelectedOrder, lastSelectedOrder);
      } else if (firstSelectedOrder.page === lastSelectedOrder.page){
        if (firstSelectedOrder.index > lastSelectedOrder.index) {
          this.swapRuns(firstSelectedOrder, lastSelectedOrder);
        }
      }
      if (this.checkIfOnlyCurrentPageSelection(firstSelectedOrder, lastSelectedOrder)) {
        this.selectWithoutRequest(firstSelectedOrder, lastSelectedOrder);
      } else {
        this.getCollectionToPage(firstSelectedOrder, lastSelectedOrder);
      }
    },

    checkIfOnlyCurrentPageSelection: function (first, last) {
      return first.page === last.page;
    },

    selectWithoutRequest: function (first, last) {
      var grid = this.ui.jqGrid,
          list = grid.find('tr');

      this.selectedRuns = [];
      list.each(_.bind(function(index, row){
        var $row = $(row),
            rowid = $row.attr('id');
        if (index >= first.index && 
            index <= last.index) {
          this.selectedRuns.push({
            rowid: rowid,
            page: this.pagination.currentPage,
            index: index
          });
        }
      }, this));
      this.checkRunsSelection();
    },

    swapRuns: function(first, last) {
      for (var key in last) {
        var temp = first[key];
        first[key] = last[key];
        last[key] = temp;
      }
    },

    getFirstSelectedOrder: function() {
      var firstSelected,
          lastPage = this.getLastPage(), 
          firstIndex = this.pagination.pageSize;
      if (this.selectedRuns.length === 0) {
        return null;
      } else {
        _.each(this.selectedRuns, function(order){
           if (order.page < lastPage) {
            lastPage = order.page;
            firstIndex = order.index;
            firstSelected = order;
           } else if (order.page === lastPage) {
            if (order.index < firstIndex) {
              firstSelected = order;
              firstIndex = order.index;
            }
           }
        });
        return firstSelected;
      }
    },

    getLastPage: function() {
      var lastPage;
      if (this.selectedRuns.length > 0) {
        lastPage = _.max(this.selectedRuns, function(run){
          return run.page;
        }).page;
      } else {
        lastPage = this.pagination.currentPage;
      }
      return lastPage;
    },

    getCollectionToPage: function (first, last) {
      var firstOrderIndex = (first.page - 1 ) * this.pagination.pageSize + (first.index - 1),
          lastOrderIndex = (last.page - 1 ) * this.pagination.pageSize + last.index,
          size = lastOrderIndex - firstOrderIndex || 1,
          params = {
            pageSize: size,
            first: firstOrderIndex,
            _search: false,
            nd: new Date().getTime(),
            rows: size,
            page: 1,
            sord: 'asc'
          };
      if (size > 100) {
        this.showWarningSelectedNumberOutOfRange();
      } else {
        $('#content-blinder').show();
        this.trigger('onLoadSelectedRunTemplates', first, last, params);
      }
    },

    showWarningSelectedNumberOutOfRange: function() {
      bootbox.alert(_.i18n('common.errorOccuredSelectedItemsNumberOutOfRange'), function () {
        return;
      });
    },

    onSelectRuns: function(first, last, runs) {
      var pageSize = this.pagination.pageSize,
          page, orderIndex;

      this.selectedRuns = [];
      _.each(runs, _.bind(function(run, index) {
        page = Math.floor((index + first.index - 1) / pageSize);
        orderIndex = index + first.index - page * pageSize;
        this.selectedRuns.push({
          rowid: run,
          page: page + first.page,
          index: orderIndex
        });
      }, this));
      this.checkRunsSelection();
    },

    onRowMultiselect: function(rowid, select) {
      var index,
          grid = this.ui.jqGrid,
          gridList = grid.find('tr'),
          row = grid.find('#' + rowid),
          order = {
            rowid: rowid,
            page: this.pagination.currentPage,
            index: gridList.index(row)
          };
      if (select) {
        this.selectedRuns.push(order);
      } else {
        index = this.selectedRuns.indexOf(_.findWhere(this.selectedRuns, {rowid: rowid}));
        this.selectedRuns.splice(index, 1);
      }
      this.onSelectedRunsChanged();
    },

    _getActionButtonsView: function() {
      var actions = ['proofsheet', 'export'],
        actionsCollection = new Backbone.Collection();
      _.each(actions, function(action) {
        actionsCollection.push(availableActions[action]);
      });

      return new ActionButtonsView({
        collection: actionsCollection,
        dontShowIcons: true
      });
    },

     _onAction: function(action) {
      switch(action) {
        default :
          throw 'Action is not supported';
      }
    },
    checkRunsSelection: function() {
      var $list = this.ui.jqGrid.find('tr');
      $list.each(_.bind(function (index, item) {
        var $item = $(item);
        if (_.some(this.selectedRuns, {rowid: $item.attr('id')})) {
          $item.addClass('selected');
        } else {
          $item.removeClass('selected');
        }
      }, this));
      this.onSelectedRunsChanged();
    },

      onSelectedRunsChanged: function() {
      if (this.selectedRuns.length > 0) {
      }
      Settings.set('selectedRunTemplates', this.selectedRuns);
    },

    onGridFilterChange: function() {
      var that = this,
        filters = {},
        value;

      _.each(this.colModel, function(column) {
        if (column.search) {
          if (column.stype === 'select') {
            value = that.$('select[name="' + column.index + '"]').val();
            filters[column.index] = value === that.selectDefault ? '' : value;
          } else if (column.sorttype === 'date') {
            value = that.$('input[name="' + column.index + '"]').val();
            if (column.index === 'modDate' && value) {
              filters.dateFrom = datePickerPopoverMixin.parseDateFrom(value);
              filters.dateTo = datePickerPopoverMixin.parseDateTo(value);
            }
          } else {
            value = that.$('input[name="' + column.index + '"]').val();
            filters[column.index] = value;
          }
        }
      });

      this.filters = filters;
      this.filterChange = true;
      this.updatePagination();
    }
  });

  module.exports = RunTemplatesView;
});
